module.exports = __webpack_public_path__ + "static/media/XyloToggle.35c590bd.mp3";